<ion-header>
  <ion-toolbar>
    <ion-title>
      @if (model.id) {
        Umfrage bearbeiten
      } @else {
        Umfrage erstellen
      }
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="inner-content">
  <form [formGroup]="form" (ngSubmit)="save()">
    <ion-list>

      <ion-item>
        <ion-input labelPlacement="floating" label="Umfrage Titel" property="title" formControlName="title"/>
      </ion-item>

      <ion-item>
        <ion-textarea labelPlacement="floating" label="Beschreibung (optional)" property="description"
                      formControlName="description"/>
      </ion-item>

      <ion-item>
        <app-take-picture class="w-full" [form]="form" [model]="model" [hasPhoto]="hasPhoto"/>
      </ion-item>

      <ion-item>
        <ion-checkbox formControlName="is_multiple_choice">
          <ion-label>Mehrfachanworten erlauben</ion-label>
        </ion-checkbox>
      </ion-item>

      <ion-item>
        <ion-label>Startdatum</ion-label>
        <ion-datetime-button
          aria-label="Sichtbar von"
          datetime="visible_from"
        />
      </ion-item>

      <ion-item class="">
        <ion-label>Enddatum</ion-label>
        <ion-datetime-button
          aria-label="Sichtbar bis"
          datetime="visible_until"
        />
      </ion-item>

      <ion-item>
        <ion-select formControlName="place_id" placeholder="Bitte wählen" label="Herausgeber" cancelText="Abbrechen">
          @for (place of places(); track place.id) {
            <ion-select-option [value]="place.id">{{ place.title }}</ion-select-option>
          }
        </ion-select>
      </ion-item>

      @if (questions.length > 0) {
        <ion-item>
          <ion-label>
            <div>Antworten:</div>
            <ul class="list-disc list-inside pl-4">
              @for (question of questions; track question.id) {
                <li class="flex justify-between">
                  <span>{{ question.title }}</span>
                  <span>
                    <ion-button fill="clear" color="danger" class="cursor-pointer" (click)="removeQuestion(question)">
                      <ion-icon slot="icon-only" name="trash"></ion-icon>
                    </ion-button>
                  </span>
                </li>
              }
            </ul>
          </ion-label>
        </ion-item>
      }


      <ion-item>
        <!-- add questions -->
        <ion-button expand="block" fill="clear" color="primary" class="cursor-pointer" (click)="addQuestion()">
          Antwort hinzufügen
        </ion-button>
      </ion-item>
    </ion-list>

    <ion-modal [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime
          id="visible_from"
          locale="de-DE"
          [min]="minDate"
          formControlName="visible_from"
        />
      </ng-template>
    </ion-modal>

    <ion-modal [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime
          id="visible_until"
          locale="de-DE"
          [min]="minDate"
          formControlName="visible_until"
        />
      </ng-template>
    </ion-modal>
  </form>
</div>

<ion-footer>
  <ion-toolbar class="ion-padding-horizontal">
    <ion-button expand="block" fill="solid" color="primary" class="cursor-pointer" (click)="save()"
                [disabled]="isLoading()">
      @if (model.id) {
        Speichern
      } @else {
        Erstellen
      }
    </ion-button>
  </ion-toolbar>
</ion-footer>
